import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { EditDate } from '../reducers/edit-date.reducer';
import * as selectors from '../selectors/edit-date.selectors';

@Injectable()
export class EditDateFacadeService extends FacadeService {
  constructor(public override store: Store<EditDate>) {
    super(store);
  }

  editDateDisabled$ = this.storeSelect(selectors.getShowEditDateButton);
  column$ = this.storeSelect(selectors.getColumn);
  date$ = this.storeSelect(selectors.getDate);
  dateFormat$ = this.storeSelect(selectors.getDateFormat);

  get column() {
    return this.storeSnapshot(this.column$);
  }

  get date() {
    return this.storeSnapshot(this.date$);
  }

  get dateFormat() {
    return this.storeSnapshot(this.dateFormat$);
  }
}
